import FooterTopBox from './FooterTopBox';

export default FooterTopBox;
